export const SHOP_FLOOR_AUTO_REFRESH_MS = 60 * 1000;